export default __webpack_public_path__ + "static/B0090-77222d17edbd9345f1d02ea27d92bfb1.png";